import React, {useContext, useState, useEffect} from 'react';
import { FormContext } from '../../Pages/Apply'
import * as Yup from 'yup';
import axios from 'axios';
import {Formik, Form} from 'formik';
import {BASE_URL} from '../../config'
import swal from 'sweetalert'
import FileUploadProgress from '../FileUploadProgress'
import {AuthContext} from '../../context/AuthContext'
import utilities from '../../utilities'

const UploadDocuments = (props) => {

    const [cnicProgress, setCNICProgress] = useState(0);
    const [matricProgress, setMatricProgress] = useState(0);
    const [verificationProgress, setVerificationProgress] = useState(0);

    const [cnicRememainingTime, setCNICRemainingTime] = useState(0);
    const [matricRememainingTime, setMatricRemainingTime] = useState(0);
    const [verificationRememainingTime, setVerificationRemainingTime] = useState(0);

    const [stepData, setStepData]= useState({matricDMCPath: '', matricVerificationPath: '', cnicPath: ''})
    const { activeStepIndex, setActiveStepIndex, formData, setFormData } = useContext(FormContext);
    const {userInfo} = useContext(AuthContext);

    const validFileExtensions = { image: ['jpg', 'png', 'jpeg'] };

    function isValidFileType(fileName, fileType) {
      return fileName && validFileExtensions[fileType].indexOf(fileName.split('.').pop()) > -1;
    }
    
    function getAllowedExt(type) {
      return validFileExtensions[type].map((e) => `.${e}`).toString()
    } 
    
    let allowedExts = getAllowedExt('image');
    const MAX_FILE_SIZE = 102400;

    const goToPreviousStep = () => {
        setActiveStepIndex(activeStepIndex - 1);
    }

    

    const myUploadProgress = (myFileId, startAt) => (progressEvent) => {

        const { loaded, total } = progressEvent;
        const percentage = (loaded * 100) / total;
        const timeElapsed = Date.now() - startAt;
        const uploadSpeed = loaded / timeElapsed;
        const duration = (total - loaded) / uploadSpeed;
        if (myFileId == "cnic")
        {
            setCNICProgress(+percentage.toFixed(2));
            setCNICRemainingTime(duration);              
        }

        if (myFileId == "matric")
        {
            setMatricProgress(+percentage.toFixed(2));
            setMatricRemainingTime(duration);              
        }

        if (myFileId == "verification")
        {
            setVerificationProgress(+percentage.toFixed(2));
            setVerificationRemainingTime(duration);              
        }

      }



  const handleFileUpload = (event, formik) => {
    let startAt = Date.now();
    const file = event.target.files[0];
    var size = file.size;

    var fileName = file.name;
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
        //TO DO
    }else{
      swal({
        title: "Attention!",
        text: 'Only jpg/jpeg and png files are allowed!',
        icon: "info",
      });
      return;      
    }   



    if (size > MAX_FILE_SIZE)
    {
      swal({
        title: "Attention!",
        text: 'only allowed 100 KB file size.',
        icon: "info",
      });

      //alert('only allowed 100 kb file size');
      return;
    }
    const fd = new FormData();
    fd.append("file", file);
    axios
      .post(BASE_URL + "/Registration/UploadDocument", fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${userInfo.jwt}`
        },
        onUploadProgress : myUploadProgress(event.target.name, startAt)

      })
      .then((response) => {
        if (event.target.name == 'cnic')
        {
            formik.setFieldValue('cnicPath', response.data)
            formik.values.cnicPath = response.data;
            const data = { ...stepData, ...formik.values };
            setStepData(data);
        }

        if (event.target.name == 'matric')
        {
            formik.setFieldValue('matricDMCPath', response.data)    
            formik.values.matricDMCPath = response.data;
            const data = { ...stepData, ...formik.values };
            setStepData(data);


        }

        if (event.target.name == 'verification')
        {
            formik.setFieldValue('matricVerificationPath', response.data)
            formik.values.matricVerificationPath = response.data;
            const data = { ...stepData, ...formik.values };
            setStepData(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validationScheme = Yup.object().shape({
    matricDMCPath: Yup.string().required("Required"),
    cnicPath: Yup.string().required("Required"),
  })


  useEffect(() => {
    setStepData((prevState) => ({
      ...prevState,
      ...formData,
    }));

    
}, []);


   const submit = async (values, { setSubmitting }) => {
    const data = { ...formData, ...values };
    setFormData(data);

    var regid = 0;
    if (data.registrationID > 0)
    {
      regid = await utilities.postData( {url: '/Registration/UpdateApplication', body: data, jwt: userInfo.jwt});
    }
    else
    {
      regid = await utilities.postData( {url: '/Registration/SaveApplication', body: data, jwt: userInfo.jwt});
    }

    if (regid > 0)
    {
      setSubmitting(false);
      setActiveStepIndex(activeStepIndex + 1);      
    }

  }
   


  return (
    <>
        <div className="">
           <Formik initialValues={stepData} validationSchema={validationScheme} onSubmit={submit} enableReinitialize={true} >
             {formik => (

               <Form style={{padding: '50px', paddingBottom: '10px'}} className='row g-3'>


              <div className='col-12'>
                  <p class="text-uppercase fs-5 fw-bold">Upload Documents</p>
              </div>
              <hr></hr>

              <div className='col-12'>
                <label>CNIC Front Side</label>
                {!userInfo.Options ? (<>
                <input type="file" class="form-control" name="cnic" accept=".jpg,.jpeg,.png" onChange={(e) => {handleFileUpload(e, formik)}}/>
                </>): (null)}

                {formik.errors.cnicPath ? (
                        <div style={{color: 'red'}}>{formik.errors.cnicPath}</div>
                      ) : null}
                <FileUploadProgress progress={cnicProgress} remaining={cnicRememainingTime} />    
            
                {stepData.cnicPath ? (<>
                <div><img src={stepData.cnicPath} style={{maxWidth: '250px', maxHeight:'250px', marginTop: '5px'}} /></div>
                <div><a href={stepData.cnicPath} target='_blank'> View Large Document </a></div></>
                ) : null}
              </div> 

              <div className='col-12 mt-4'>
                <label>Matric Result Card</label>

                {!userInfo.isPortalLocked ? (<>
                  <input type="file" class="form-control" name="matric"  accept=".jpg,.jpeg,.png" onChange={(e) => {handleFileUpload(e, formik)}}/>
                </>): (null)}


                {formik.errors.matricDMCPath ? (
                        <div style={{color: 'red'}}>{formik.errors.matricDMCPath}</div>
                      ) : null}
                <FileUploadProgress progress={matricProgress} remaining={matricRememainingTime} />
                {stepData.matricDMCPath ? (<>
                  <div><img src={stepData.matricDMCPath} style={{maxWidth: '250px', maxHeight:'250px', marginTop: '5px'}} /></div>
                  <div><a href={stepData.matricDMCPath} target='_blank'> View Large Document </a></div></>
                ) : null}                                
              </div> 

              <div className='col-12 mt-4'>
                <label>Matric Verification</label>

                {!userInfo.isPortalLocked ? (<>
                  <input type="file" class="form-control" name="verification" accept=".jpg,.jpeg,.png" onChange={(e) => {handleFileUpload(e, formik)}}/>
                </>): (null)}


                <FileUploadProgress progress={verificationProgress} remaining={verificationRememainingTime} />
                {stepData.matricVerificationPath ? (<>
                  <div><img src={stepData.matricVerificationPath} style={{maxWidth: '250px', maxHeight:'250px', marginTop: '5px'}} /></div>
                  <div><a href={stepData.matricVerificationPath} target='_blank'> View Large Document </a></div></>
                ) : null}                                
              </div> 


              <div className="d-flex justify-content-between gap-4 pb-3 pt-4">
                    <button className="btn btn-secondary w-50" type="button" onClick={goToPreviousStep}> Previous </button>

                    {!userInfo.isPortalLocked ? (<>
                      <button className="btn btn-primary w-50" type="submit" disabled={!(formik.isValid) || formik.isSubmitting}>
                    {formik.isSubmitting ? 
                    (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : 
                    (<span >SUBMIT</span>)
                        }
                    </button>

                </>): (null)}



                </div>
               </Form>
             )}
           </Formik>      
       </div>  
    </>
  );

};

export default UploadDocuments;
